import { onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import useTransactionsStore from '@/store/modules/transactions';
import { useAuthStore } from '@/store/modules/auth';
import SellPendingDeposit from '@/components/sell/SellPendingDeposit.vue';
import { MIXPANEL_EVENTS, trackEvent } from '@/utils/mixpanel';
import { getChannelLabel } from '@/utils/helpers';
import SellDepositNotFound from './SellDepositNotFound.vue';
import TransactHeader from '../transact/TransactHeader.vue';
import LoaderComponent from '../general/LoaderComponent.vue';
export default {
    components: {
        TransactHeader,
        SellPendingDeposit,
        SellDepositNotFound,
        LoaderComponent,
    },
    setup() {
        const transactionStore = useTransactionsStore();
        const { payment, paymentFound, loading, loadingMessage, selectedChannel } = storeToRefs(transactionStore);
        const authStore = useAuthStore();
        const { partnerId } = storeToRefs(authStore);
        const { fetchPayment } = transactionStore;
        onMounted(async () => {
            loading.value = true;
            loadingMessage.value = 'Fetching payment';
            try {
                await fetchPayment();
                loading.value = false;
                loadingMessage.value = '';
            }
            catch (e) {
                loading.value = false;
                loadingMessage.value = '';
            }
            trackEvent(MIXPANEL_EVENTS.SELL.EOF, {
                payment_method: getChannelLabel(selectedChannel.value),
                partner: partnerId.value,
                success: paymentFound.value,
            });
        });
        return {
            payment,
            paymentFound,
            loading,
        };
    },
};
